import { Component, Input, OnInit } from '@angular/core'
import { combineLatest, Observable } from 'rxjs'
import { DealConfigurationQuery } from 'generated/graphql'
import { currentYear, getNetBijtellingPerMonth, nextYear } from '@mistergreen/shared/utilities/bijtelling'
import { getDealOptionByKey } from 'modules/deals/utilities/deal-helpers'
import { SelectableDealOption } from 'modules/deals/utilities/deal-types'
import { FormControl } from '@angular/forms'
import { startWith } from 'rxjs/operators'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
    selector: 'mg-deal-bijtelling',
    templateUrl: './deal-bijtelling.component.html',
    styleUrls: ['./deal-bijtelling.component.scss'],
})
export class DealBijtellingComponent implements OnInit {
    taxBracket: FormControl = new FormControl(1)
    ownContribution: FormControl = new FormControl('')

    fiscalValue: number

    bijtellingCurrentYearPerMonth: string
    bijtellingCurrentYearPerYear: string
    bijtellingNextYearPerMonth: string
    bijtellingNextYearPerYear: string
    bijtellingSavingsPerMonth: string
    bijtellingSavingsPerYear: string
    bijtellingSavingsOverDuration: string

    @Input() deal$: Observable<DealConfigurationQuery['Deal']>

    constructor() {}

    ngOnInit() {
        combineLatest([
            this.deal$,
            this.taxBracket.valueChanges.pipe(startWith(1)),
            this.ownContribution.valueChanges.pipe(startWith(0)),
        ])
            .pipe(untilDestroyed(this))
            .subscribe(([deal, taxBracket, ownContribution]) => {
                this.fiscalValue = deal.pricing.fiscalValue
                ownContribution = ownContribution || 0

                const duration = getDealOptionByKey(deal.options, 'duration') as SelectableDealOption

                const bijtellingCurrentYearPerMonth = getNetBijtellingPerMonth({
                    bijtellingYear: currentYear,
                    fiscalValue: deal.pricing.fiscalValue,
                    ownContributionPerMonth: ownContribution,
                    taxBracketNr: taxBracket,
                })

                const bijtellingNextYearPerMonth = getNetBijtellingPerMonth({
                    bijtellingYear: nextYear,
                    fiscalValue: deal.pricing.fiscalValue,
                    ownContributionPerMonth: ownContribution,
                    taxBracketNr: taxBracket,
                })

                this.bijtellingCurrentYearPerMonth = bijtellingCurrentYearPerMonth.toFixed(0)
                this.bijtellingCurrentYearPerYear = (bijtellingCurrentYearPerMonth * 12).toFixed(0)
                this.bijtellingNextYearPerMonth = bijtellingNextYearPerMonth.toFixed(0)
                this.bijtellingNextYearPerYear = (bijtellingNextYearPerMonth * 12).toFixed(0)
                this.bijtellingSavingsPerMonth = (bijtellingNextYearPerMonth - bijtellingCurrentYearPerMonth).toFixed(0)
                this.bijtellingSavingsPerYear = (
                    (bijtellingNextYearPerMonth - bijtellingCurrentYearPerMonth) *
                    12
                ).toFixed(0)
                this.bijtellingSavingsOverDuration = (
                    parseInt(this.bijtellingSavingsPerMonth) * parseInt(duration.selectedValue.label)
                ).toFixed(0)
            })
    }
}
